import script from "./ValidationDetailModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ValidationDetailModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__